import Select from 'react-select';
import CustomMenuList from './CustomMenuList';
import CustomPlaceholder from './CustomPlaceholder';
import { useTranslation } from 'react-i18next';

const Passengers = () => {
  const { t } = useTranslation();

  return (
    <div>
      <label className="text-sm mb-2 block px-2">{t('Select passengers')}</label>
      <Select
        name="passengers"
        menuShouldScrollIntoView={false}
        isSearchable={false}
        unstyled
        components={{
          MenuList: (menuListProps) => CustomMenuList({ menuListProps }),
          Placeholder: (placeholderProps) => CustomPlaceholder({ placeholderProps }),
          IndicatorSeparator: null,
        }}
        classNames={{
          control: (state) => {
            return `w-full h-12 bg-white border border-input-gray px-4 focus:ring-2 ${
              state.menuIsOpen ? 'ring-2 ring-gray-500 rounded-t' : 'rounded'
            } ${state.isFocused ? 'ring-2 ring-gray-500' : 'rounded'}`;
          },
          menuList: () =>
            'bg-white border-t-none rounded-b ring-gray-500 ring-2 mt-0 !max-h-[350px]',
        }}
      />
    </div>
  );
};

export default Passengers;
